import { IEscrowBankAccountResponse } from '../../../accounting/response/IEscrowBankAccountResponse';
import { IPropertyAddressResponse } from '../../../address/IPropertyAddressResponse';
import { eManualCheckDisbursementCategory } from '../../../accounting/eManualCheckDisbursementCategory';
import { eCheckVoidReason } from '../../../accounting/eCheckVoidReason';
import { IManualCheckDisbursementData } from '../IManualCheckDisbursementData';
import { IEscrowFileData } from '../../../accounting/data/IEscrowFileData';
import { IHoldbackDisbursement } from '../IHoldbackDisbursement';

export interface IManualCheckDisbursementResponse extends IHoldbackDisbursement {
  id: string;
  amountCents: number;
  checkNumber: string;
  name: string;
  additionalName?: string;
  memo: string;
  sentAt?: string;
  createdAt?: string;
  updatedAt?: string;
  category: eManualCheckDisbursementCategory;
  completedAt?: string;
  checkPDFFileName?: string;
  checkPDFContentType?: string;
  checkPDFFileSize?: number;
  checkPDFUpdatedAt?: string;
  createdAtDate?: string;
  completedAtDate?: string;
  sentAtDate?: string;
  voidedAt?: string;
  voiderId?: string;
  checkDate?: string;
  voidReason?: eCheckVoidReason;
  voidReasonDescription?: string;
  stopPayNeeded?: boolean;
  checkInHand?: boolean;
  escrowFile: IEscrowFileData;
  mailingAddress?: IPropertyAddressResponse;
  escrowBankAccount: IEscrowBankAccountResponse;
  shipmentType?: string;
  trackingNumber?: string;
  trackingUrl?: string;
  printedDate?: string;
}

export const convertIManualCheckDisbursementResponseToIManualCheckDisbursementData = ({
  id,
  amountCents,
  holdback,
  holdbackProperties,
  checkNumber,
  name,
  additionalName,
  memo,
  sentAt,
  createdAt,
  updatedAt,
  category,
  completedAt,
  checkPDFFileName,
  checkPDFContentType,
  checkPDFFileSize,
  checkPDFUpdatedAt,
  createdAtDate,
  completedAtDate,
  sentAtDate,
  voidedAt,
  voiderId,
  checkDate,
  voidReason,
  voidReasonDescription,
  stopPayNeeded,
  checkInHand,
  escrowFile,
  mailingAddress,
  escrowBankAccount,
  shipmentType,
  trackingNumber,
  trackingUrl,
  printedDate,
}: IManualCheckDisbursementResponse): IManualCheckDisbursementData => {
  return {
    id,
    checkNumber,
    name,
    mailingAddress,
    amountCents,
    holdback,
    holdbackProperties,
    escrowBankAccount,
    category,
    memo,
    sentAt,
    completedAt,
    completedAtDate,
    voidedAt,
    voiderId,
    voidReason,
    voidReasonDescription,
    createdAt: createdAtDate,
    checkDate: checkDate || undefined,
    sentAtDate,
    shipmentType,
    trackingNumber,
    trackingUrl,
    printedDate,
  };
};
